import i18n from "../i18n";

// The label is read when it is shown, so it follows the website's language
// (admin:filters.*); the value is what the API filters on and does not change.
// Carrier names stay as they are, except Canada Post (Postes Canada in French).
const option = (key, value) => ({
  get label() {
    return i18n.t(key);
  },
  value,
});

export const carrierFilterOptions = [
  { label: "UPS", value: "ups" },
  { label: "GLS", value: "gls" },
  { label: "Ics", value: "ics" },
  { label: "Canpar", value: "canpar" },
  option("admin:filters.carriers.canadaPost", "canada post"),
  { label: "Vitran", value: "vitran" },
  { label: "Day & Ross", value: "day & ross" },
  { label: "MO", value: "mo" },
  { label: "XPO", value: "xpo" },
  { label: "DHL", value: "dhl" },
  { label: "Kindersley Transport", value: "kindersley transport" },
  { label: "Nationex", value: "nationex" },
  { label: "Fedex", value: "fedex" },
  { label: "Loomis Express", value: "loomis express" },
];

export const shipmentStatusFilterOptions = [
  option("admin:filters.shipmentStatus.creation", "creation"),
  option("admin:filters.shipmentStatus.labelCreated", "label created"),
  option("admin:filters.shipmentStatus.pickup", "pickup"),
  option("admin:filters.shipmentStatus.inTransit", "in transit"),
  option("admin:filters.shipmentStatus.onTheWay", "on the way"),
  option("admin:filters.shipmentStatus.outForDelivery", "out for delivery"),
  option("admin:filters.shipmentStatus.delivered", "delivered"),
  option("admin:filters.shipmentStatus.clearanceInProgress", "clearance in progress"),
  option("admin:filters.shipmentStatus.delay", "delay"),
  option("admin:filters.shipmentStatus.returnedToSender", "returned to sender"),
  option("admin:filters.shipmentStatus.cancelled", "cancelled"),
];

export const invoiceStatusFilterOptions = [
  option("admin:invoiceStatus.Unpaid", "Unpaid"),
  option("admin:invoiceStatus.Extra Charge Paid", "Extra Charge Paid"),
  option("admin:invoiceStatus.Less Charge Paid", "Less Charge Paid"),
  option("admin:invoiceStatus.Paid", "Paid"),
  option("admin:invoiceStatus.Disputed", "Disputed"),
  option("admin:invoiceStatus.Duty Disputed", "Duty Disputed"),
  option("admin:invoiceStatus.Dispute Won", "Dispute Won"),
  option("admin:invoiceStatus.Dispute Lost", "Dispute Lost"),
  option("admin:invoiceStatus.Refunded", "Refunded"),
  option("admin:invoiceStatus.Other", "Other"),
];

export const invoiceBillFilterOptions = [
  option("admin:filters.bill.unverified", "Unverified"),
  option("admin:filters.bill.verified", "Verified"),
];

export const dutiesFilterOptions = [
  option("admin:filters.duties.paid", "Paid"),
  option("admin:filters.duties.unpaid", "Unpaid"),
];

export const fulfilmentFilterOptions = [
  option("admin:filters.fulfilment.pending", "pending"),
  option("admin:filters.fulfilment.packing", "packing"),
  option("admin:filters.fulfilment.fulfilled", "fulfilled"),
  option("admin:filters.fulfilment.attention", "attention"),
];

export const typeFilterOptions = [
  option("admin:filters.type.marketplace", "marketplace"),
  option("admin:filters.type.manual", "manual"),
  option("admin:filters.type.selfPickup", "self pickup"),
  option("admin:filters.type.selfDelivery", "self delivery"),
];

export const fulfilmentBillingFilterOptions = [
  option("admin:filters.fulfilmentBilling.paid", "paid"),
  option("admin:filters.fulfilmentBilling.unpaid", "unpaid"),
  option("admin:filters.fulfilmentBilling.dispute", "dispute"),
];
